import { LazyLoad } from 'app/utils';

export const PopUpBannerFormListPage = LazyLoad(
  () => import('./index'),
  (module) => module.PopUpBannerFormPage,
);
